<template>
  <section class="card">
    <h2 class="section-title">
      {{ title }}
    </h2>

    <div class="signature-wrapper">
      <canvas ref="canvas" class="signature-canvas"></canvas>
    </div>

    <div class="flex gap-3 mt-3">
      <button type="button" class="btn-outline" @click="clear">
        {{ clearLabel }}
      </button>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, watch, onBeforeUnmount  } from 'vue'
import SignaturePad from 'signature_pad'

const props = defineProps({
  modelValue: String,
  title: String,
  clearLabel: {
    type: String,
    default: 'Clear',
  },
  note: String,
})

const emit = defineEmits(['update:modelValue'])

const canvas = ref(null)
let signaturePad = null

const resizeCanvas = () => {
  if (!canvas.value) return
  const ratio = Math.max(window.devicePixelRatio || 1, 1)
  canvas.value.width = canvas.value.offsetWidth * ratio
  canvas.value.height = 200 * ratio
  canvas.value.getContext('2d').scale(ratio, ratio)
}

const initSignaturePad = () => {
  if (!canvas.value) return

  signaturePad = new SignaturePad(canvas.value, {
    backgroundColor: 'rgb(255,255,255)',
  })

  // Listen for stroke end
  signaturePad.addEventListener('endStroke',emitValue);

  // If initial value exists, draw it
  if (props.modelValue) {
    signaturePad.fromDataURL(props.modelValue)
  }
}

const emitValue = () => {  
  if (!signaturePad) return
  emit('update:modelValue', signaturePad.toDataURL())
}

const clear = () => {
  signaturePad.clear()
  emit('update:modelValue', '')
}

onMounted(() => {
  resizeCanvas()
  initSignaturePad()
  window.addEventListener('resize', resizeCanvas)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', resizeCanvas)
  if (canvas.value) {
    canvas.value.removeEventListener('mouseup', emitValue)
    canvas.value.removeEventListener('touchend', emitValue)
  }
})

watch(() => props.modelValue, (value) => {
  if (!value || !signaturePad) return
  signaturePad.fromDataURL(value)
})
</script>

<style scoped>
.signature-wrapper {
  border: 1px dashed #d1d5db;
  border-radius: 8px;
  padding: 8px;
  background: #fafafa;
}

.signature-canvas {
  width: 100%;
  height: 200px;
  touch-action: none;
  pointer-events: auto;
}

.btn-outline {
  padding: 6px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
}
</style>
